const styles = {
  card: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    boxShadow: "6px 6px 10px #0000001A",
    borderRadius: 12,
    backgroundColor: "#fff",
  },
  title: {
    padding: "0.5rem 1rem",
    fontSize: "20px",
  },
  main: {
    padding: "0.5rem",
    flex: 1,
  },
  footer: {
    display: "flex",
    padding: "3px 18px",
    minHeight: 18,
    justifyContent: "flex-end",
    backgroundColor: "#043D90",
    borderBottomRightRadius: 12,
    borderBottomLeftRadius: 12,
  },
};

export default styles;
